import { _mutations } from './mutation-types'

export const mutations = {
  [_mutations.RESET_PROJECTS] (state) {
    state.projects = null
  },
  [_mutations.RESET_PACKAGES] (state) {
    state.packages = null
  },
  [_mutations.SET_PROJECTS] (state, projects) {
    state.projects = projects || []
  },
  [_mutations.SET_PACKAGES] (state, packages) {
    state.packages = packages || []
  },
  [_mutations.RESET_CATALOG] (state) {
    state.catalog = null
  },
  [_mutations.SET_CATALOG] (state, catalog) {
    state.catalog = catalog || []
  },
  [_mutations.UPDATE_ACTIVE_PROJECT] (state, project) {
    state.activeProject = project
  },
  [_mutations.OPEN_COMMIT_CHANGES_DIALOG] (state) {
    state.commitChangesDialogVisible = true
  },
  [_mutations.CLOSE_COMMIT_CHANGES_DIALOG] (state) {
    state.commitChangesDialogVisible = false
  },
  [_mutations.RESET_UNCOMMITTED_COMPONENTS] (state) {
    state.uncommittedComponents.loading = false
    state.uncommittedComponents.loaded = false
    state.uncommittedComponents.value = null
    state.uncommittedComponents.error = null
  },
  [_mutations.START_LOADING_UNCOMMITTED_COMPONENTS] (state) {
    state.uncommittedComponents.loading = true
    state.uncommittedComponents.error = null
  },
  [_mutations.STOP_LOADING_UNCOMMITTED_COMPONENTS] (state) {
    state.uncommittedComponents.loading = false
  },
  [_mutations.SET_UNCOMMITTED_COMPONENTS_LOADED] (state) {
    state.uncommittedComponents.loaded = true
  },
  [_mutations.SET_UNCOMMITTED_COMPONENTS] (state, uncommittedComponents) {
    state.uncommittedComponents.value = uncommittedComponents
  },
  [_mutations.SET_UNCOMMITTED_COMPONENTS_ERROR] (state, error) {
    state.uncommittedComponents.error = error
  },
  [_mutations.OPEN_PROJECT_DEPLOYMENT_DIALOG] (state) {
    state.projectDeploymentDialogVisible = true
  },
  [_mutations.CLOSE_PROJECT_DEPLOYMENT_DIALOG] (state) {
    state.projectDeploymentDialogVisible = false
  }
}
